<template>
  <div class="p-person">
    <template v-if="person.VALUE != '1'">
      <input
        type="checkbox"
        :id="person.ID"
        class="c-checkbox"
        v-model="checkboxInsured"
      />
      <label
        :for="person.ID"
        class="c-checkbox--label p-person__title p-person__title--checkbox"
        >{{ person.LABEL }}</label
      >
    </template>
    <p v-else class="p-person__title">{{ person.LABEL }}</p>
    <div class="p-person__body">
      <dl class="p-person__form">
        <dt class="p-person__form__title"><p>性別</p></dt>
        <dd class="p-person__form__data">
          <ul class="p-person__form__gender">
            <li
              v-for="gender in genders"
              :key="gender.VALUE"
              class="p-person__form__gender__item"
            >
              <input
                type="radio"
                :id="person.ID + 'g' + gender.VALUE"
                class="c-radio"
                :value="gender.LABEL"
                v-model="radioGender"
                :disabled="!checkboxInsured"
              />
              <label
                :for="person.ID + 'g' + gender.VALUE"
                class="c-radio--label"
                >{{ gender.LABEL }}</label
              >
            </li>
          </ul>
        </dd>
      </dl>
      <dl class="p-person__form">
        <dt class="p-person__form__title"><p>年齢</p></dt>
        <dd class="p-person__form__data">
          <div class="p-person__form__age">
            <select
              v-model="selectAge"
              class="c-select p-person__form__age__select"
              :disabled="!checkboxInsured"
            >
              <option v-for="i in ages" :key="i" :value="i">{{ i }}</option>
            </select>
            <p class="p-person__form__age__years">歳</p>
          </div>
          <p class="p-person__form__note">
            ※2026年7月1日時点の満年齢をお選びください
          </p>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
import { GENDER_LABELS, PERSON_LABELS } from "@/const.js";
import { mapGetters } from "vuex";
export default {
  name: "PersonForm",
  beforeMount() {
    this.validating();
  },
  props: {
    person: Object,
  },
  data() {
    return {
      validated: false,
    };
  },
  computed: {
    ...mapGetters(["getPerson"]),
    genders() {
      return GENDER_LABELS;
    },
    persons() {
      return PERSON_LABELS;
    },
    personId() {
      return this.person.ID;
    },
    ages() {
      let arr = [];
      switch (this.personId) {
        case "p1":
        case "p2":
          for (let i = 15; i < 76; i++) {
            arr.push(i);
          }
          break;
        case "p3":
        case "p4":
          for (let i = 3; i < 23; i++) {
            arr.push(i);
          }
          break;
        default:
          break;
      }
      return arr;
    },
    checkboxInsured: {
      get() {
        return this.getPerson(this.personId).insured;
      },
      set(value) {
        this.$store.commit("updateInsured", { value, personId: this.personId });
        // this.clearValues();
        this.validating();
      },
    },
    radioGender: {
      get() {
        return this.getPerson(this.personId).gender;
      },
      set(value) {
        this.$store.commit("updateGender", { value, personId: this.personId });
        this.validating();
      },
    },
    selectAge: {
      get() {
        return this.getPerson(this.personId).age;
      },
      set(value) {
        this.$store.commit("updateAge", { value, personId: this.personId });
        this.validating();
      },
    },
  },
  methods: {
    clearValues() {
      this.radioGender = null;
      this.selectAge = null;
    },
    validating() {
      // console.log("insured:" + !this.checkboxInsured);
      // console.log("gender:" + this.radioGender);
      // console.log("age:" + this.selectAge);
      this.validated =
        (!!this.radioGender && !!this.selectAge) || !this.checkboxInsured;
      this.$emit("update-condition", this.validated);
    },
  },
};
</script>

<style scoped lang="scss">
.p-person {
  @include pc {
    width: 359px;
  }
  @include sp {
    margin-bottom: 16px;
  }
  &__title {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $color-blue;
    color: #fff;
    width: 103px;
    height: 35px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    font-weight: 800;
    font-size: 14px;
    &--checkbox {
      justify-content: flex-start;
      padding-left: 36px;
    }
  }
  &__body {
    background-color: #fff;
    padding: 30px 14px 0;
    height: 176px;
  }
  &__form {
    display: flex;
    &:first-of-type {
      margin-bottom: 18px;
    }
    &__title {
      color: $color-blue;
      width: 35px;
      font-size: 12px;
    }
    &__data {
      width: calc(100% - 35px);
    }
    &__gender {
      display: flex;
      justify-content: space-between;
    }
    &__age {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      &__select {
        width: calc(100% - 25px);
        height: 53px;
        text-align: center;
        font-weight: 800;
        font-size: 18px;
        font-family: $font-gothic;
        &:hover:not([disabled]) {
          cursor: pointer;
        }
      }
      &__years {
        width: 25px;
        text-align: right;
        font-weight: 800;
        font-size: 18px;
      }
    }
    &__note {
      margin-top: 5px;
      @include pc {
        font-size: 12px;
      }
      @include sp {
        font-size: 12px;
      }
    }
  }
}
</style>